import { getStudentCategories, getCategoryCount } from '../../utils/profileUtils';

const CategoryFilters = ({ 
  messages, 
  activeStudent, 
  activeCategory, 
  setActiveCategory 
}) => {
  if (!activeStudent) return null;

  return (
    <div className="flex flex-wrap gap-2 p-4 bg-gray-50 border-t border-b border-gray-200">
      {[...getStudentCategories(messages, activeStudent)].map((category) => (
        <button
          key={category}
          onClick={() => setActiveCategory(category)}
          className={`px-3 py-1 rounded-md text-sm flex items-center gap-1 ${
            activeCategory === category 
              ? 'bg-blue-500 text-white' 
              : 'bg-gray-200 hover:bg-gray-300'
          }`}
        >
          {category}
          <span className="text-xs ml-1">
            ({getCategoryCount(messages, activeStudent, category)})
          </span>
        </button>
      ))}
    </div>
  );
};

export default CategoryFilters;
